import { DownOutlined } from '@ant-design/icons';
import { Breadcrumb, Dropdown, Menu } from 'antd';
import paths from 'pages/Router/paths';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { setActiveTab } from 'state/actions/tab';
import { log } from 'utils';
import './Home.css';

function Home({ history }) {
  const { organizationsList, sites, userData, role } = useSelector(
    (state) => ({
      organizationsList: state.organizations.list,
      sites: state.sites.list,
      userData: state.auth.userData,
      role: state.auth.userData.role,
    }),
    shallowEqual
  );
  const [activeOrg, setActiveOrg] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    if (userData.role !== 'superadmin') {
      const userAccess = userData.roleAccess
        ? userData.roleAccess.access
        : userData.access;

      // console.log(userData);

      const active = activeOrg ?? [];
      sites.map((site) => {
        const dataSite = userAccess.find((acc) => acc.siteId === site._id);
        if (dataSite) {
          if (dataSite.arrival_landmark || dataSite.activity_pillar) {
            !active.includes(site.organizationId) &&
              active.push(site.organizationId);
            return null;
          } else {
            return null;
          }
        } else {
          return null;
        }
      });
      setActiveOrg(active);
      // console.log(activeOrg);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    // console.log(activeOrg)
  }, [activeOrg]); // eslint-disable-line react-hooks/exhaustive-deps

  const goTo = (toWhere, siteId, siteName) => {
    log(siteId, siteName, '<<< GO TO');
    dispatch(setActiveTab({ tab: toWhere }));
    history.push(`/${siteId}/information/${siteName}`); // eslint-disable-line react-hooks/exhaustive-deps
    sessionStorage.setItem('activeMenu', 'site');
  };

  const resetPassword = (!userData.isPasswordChanged ||
    userData.isPasswordExpired) && <Redirect to={paths.RESET_PASSWORD} />;
  // console.log(userData);
  const redirect = !role && <Redirect to={paths.ROOT} />;
  const validateAccessMenu = (crud) => {
    if (typeof crud !== 'object') return crud;
    return Object.values(crud).includes(true);
  };

  const api = (site) => (
    <Menu
      onClick={(e) => {
        goTo(e.key, site._id, site.name);
      }}
    >
      <Menu.Item key="activity-pillar">
        <div>
          <i className="feather-book" /> Gallery Highlights
        </div>
      </Menu.Item>
      <Menu.Item key="curated-playlist">
        <div>
          <i className="feather-book" /> Curated Playlists
        </div>
      </Menu.Item>
      <Menu.Item key="social-wall">
        <div>
          <i className="feather-image" /> Visitor Gallery
        </div>
      </Menu.Item>

      <Menu.Item key="wayfinding">
        <div>
          <i className="feather-book" /> Wayfinding
        </div>
      </Menu.Item>
    </Menu>
  );

  return (
    <div className="dashboard">
      {resetPassword}
      {redirect}
      <div className="breadcrumb-wrapper">
        <Breadcrumb>
          <Breadcrumb.Item>Home</Breadcrumb.Item>
          <Breadcrumb.Item className="breadcrumb-active">
            Dashboard
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <h1 className="page-title">Dashboard</h1>

      {userData.role === 'superadmin'
        ? // eslint-disable-next-line

          organizationsList.map((organization) => {
            return (
              <div className="dashboard-table" key={organization._id}>
                <h1 className="title">{organization.name}</h1>
                <div className="dashboard-row-wrapper">
                  {sites &&
                    sites
                      .filter(
                        (site) => site.organizationId === organization._id
                      )
                      .map((site) => (
                        <div className="dashboard-row" key={site._id}>
                          <Link to={`/${site._id}/information/${site.name}`}>
                            <span className="dashboard-span">{site.name}</span>
                          </Link>
                          {/* <ul className="service-list">
                            <li>
                              <Dropdown
                                overlay={() => api(site)}
                                placement="bottomCenter"
                              >
                                <div onClick={(e) => e.preventDefault()}>
                                  <i className="feather-airplay" /> Activity
                                  Pillar <DownOutlined />
                                </div>
                              </Dropdown>
                            </li>

                            <li
                              onClick={() =>
                                goTo('arrival-landmark', site._id, site.name)
                              }
                            >
                              <i className="feather-map" />
                              Arrival Landmark
                            </li>

                             <li
                              onClick={() =>
                                goTo('feedback', site._id, site.name)
                              }
                            >
                              <i className="feather-rss" /> Feedbacks
                            </li> 
                          </ul> */}
                        </div>
                      ))}
                </div>
              </div>
            );
          })
        : // eslint-disable-next-line

          organizationsList.map((organization) => {
            const siteOrg = sites.filter(
              (site) => site.organizationId === organization._id
            );
            if (activeOrg) {
              // console.log(activeOrg)
              if (activeOrg.includes(organization._id)) {
                // console.log(organization._id)
                return (
                  <div className="dashboard-table" key={organization._id}>
                    <h1 className="title">{organization.name}</h1>
                    <div className="dashboard-row-wrapper">
                      {siteOrg.map((site) => {
                        const access = userData.roleAccess
                          ? userData.roleAccess.access.find(
                              (acc) => acc.siteId === site._id
                            )
                          : userData.access.find(
                              (acc) => acc.siteId === site._id
                            );
                        if (
                          access &&
                          (access.activity_pillar || access.arrival_landmark)
                          // || access.maps
                        ) {
                          return (
                            <div className="dashboard-row" key={site._id}>
                              <Link
                                to={`/${site._id}/information/${site.name}`}
                              >
                                <span className="dashboard-span">
                                  {site.name}
                                </span>
                              </Link>
                              <ul className="service-list">
                                {validateAccessMenu(access.activity_pillar) && (
                                  <li>
                                    <Dropdown
                                      overlay={() => api(site)}
                                      placement="bottomCenter"
                                    >
                                      <div onClick={(e) => e.preventDefault()}>
                                        <i className="feather-airplay" />{' '}
                                        Activity Pillar <DownOutlined />
                                      </div>
                                    </Dropdown>
                                  </li>
                                )}

                                {validateAccessMenu(
                                  access.arrival_landmark
                                ) && (
                                  <li
                                    onClick={() =>
                                      goTo(
                                        'arrival-landmark',
                                        site._id,
                                        site.name
                                      )
                                    }
                                  >
                                    <i className="feather-map" />
                                    Arrival Landmark
                                  </li>
                                )}
                              </ul>
                            </div>
                          );
                        } else {
                          return <></>;
                        }
                      })}
                    </div>
                  </div>
                );
              } else {
                return <></>;
              }
            } else {
              return <></>;
            }
          })}
    </div>
  );
}

export default Home;
